// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__3w1Wi","link":"footer_link__13Sik"};